<template>
  <div ref="trapRef">
    <div class="menu-container">
          <div class="grid">
            <div class="grid-sizer"></div>
            <div class="scroll">
              <div v-for="image in images" :key="image.id" class="grid-item">
              <img :src="image.url" alt="">
              <div class="menu-card-content">
                <h3 class="mb-5">{{image.firstName}} {{image.lastName}}</h3>
                <h4 class="mb-5">{{image.job}}</h4>
                <blockquote class="mb-6">{{image.quote}}</blockquote>
                <button @click="$emit('findProfile', image.anchor)" class="button is-large show-more-btn">Read more</button>
              </div>
              </div>
            </div>
      </div>
    </div>
          <div @click="$emit('closeMenu')"  class="menu-btn-close">
            <q-btn color="primary">
              <q-icon left size="3em" name="menu" />
              <div>Close</div>
            </q-btn>  
          </div>
  </div>

</template>

<script>
import {computed, onMounted, ref,} from 'vue'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
import useFocusTrap from '../composable/useFocusTrap.js'

export default {
    props: [ "images" ],
    setup(props, {emit}) {

    const { trapRef } = useFocusTrap();

    const handleMenuClick = (name) => {
      emit('findProfile', name) 
      emit('closeMenu') 
    }

      // const profileOrderNew = computed(() => {
      //    return props.images.sort((a, b) => a.lastName.localeCompare(b.lastName))
      // })

  
    onMounted(() => {

      var grid = document.querySelector('.grid');
      var msnry;

      msnry = new Masonry( grid, {
        isFitWidth: true,
        itemSelector: '.grid-item', 
        gutter: 20,
          // columnWidth: 100,
      });

      return { msnry }
    })


    return { handleMenuClick, trapRef }

    }

}
</script>

<style lang="scss">

@mixin respond($breakpoint) {
    @if $breakpoint == phone {
        @media only screen and (max-width: 37.5em) { @content };    //600px
    }
}

 .grid-item {
  // margin: 25px 0;
  float: left;
  width: 42rem;
  margin: 0; padding: 0;

  @include respond(phone) {
    width: 100%;
    padding: 1.5rem;
  }
  }

  .grid {
    animation: menu-animation .5s ease-out;
  }

  .menu-container {
    & blockquote {

      &::before, &::after {
        content: '"';
      }

      font-size: 2rem;
      line-height: 1.6;
    }
  }

  @keyframes menu-animation {
   from {
      transform: translateY(150px);
    } to {
      transform: translateY(0px);
    }
  }
</style>